
<script>import Loader from '/app/components/Loader.html'
import { tween } from 'svelte-extras'
import * as eases from 'eases-jsnext'
import { setFocus } from '/helpers/misc'

export default {

	data() {
		return {
			pagesize: 10,
		}
	},

	computed: {
		filteredItems: (items, tag) => {
			// filter, truncate, and sort
			if (tag) {
				items = _.filter(items, item => {
					const lowerTags = _.map(item.tags, item => item.toLowerCase())
					return lowerTags.indexOf(tag.toLowerCase()) > -1
				})
			}
			items = _.map(items, item => {
				if (item.summary && item.summary.length > 200) {
					const pieces = item.summary.slice(0, 200).split(' ')
					pieces.pop()
					item.summary = pieces.join(' ') + ' . . .'
				}
				return item
			})
			// return items
			return _.orderBy(items, 'timestamp', 'desc')
		},
		paginatedItems: (filteredItems, page, pagesize) => {
			const start = (page - 1) * pagesize
			filteredItems = filteredItems.slice(start, start + pagesize)
			return filteredItems
		},
		navRange: (filteredItems, pagesize) => _.range(1, (filteredItems.length / pagesize) + 1),
		navItems: (filteredItems, page, navRange) => {
			const length = navRange.length
			const pageIndex = page - 1

			// some crazy pagination gatekeeping here, watch out...

			//   1  (2)  3   4   5				✅
			//   1   …   3  (4)  5   …   7		✅
			//   1  (2)  3   …   6				✅
			//   1   2  (3)  4   …   6			✅
			//   1   …   3  (4)  5   6			✅
			//       1   …   4  (5)  6			✅

			let navItems = _.map(navRange, (value, index) => {
				const navItem = { value }
				if (index === pageIndex) {
					navItem.on = true
				}
				if (length > 5) { // more than 5 pages means put `...` somewhere
					navItem.use = false // default
					if (index === pageIndex - 1) { navItem.use = true }
					if (index === pageIndex) { navItem.use = true }
					if (index === pageIndex + 1) { navItem.use = true }
				} else { // five or less just show them all
					navItem.use = true
				}
				return navItem
			})
			if (length > 5) {
				if (page === 1) {
					navItems[2].use = true
					navItems[3].etc = true
					navItems[length - 1].use = true
				} else if (page === 2) {
					navItems[4].etc = true
					navItems[length - 1].use = true
				} else if (page === 3) {
					navItems[0].use = true
					navItems[4].etc = true
					navItems[length - 1].use = true
				} else if (pageIndex === length - 1) {
					navItems[0].use = true
					navItems[length - 4].etc = true
					navItems[length - 3].use = true
				} else if (pageIndex === length - 2) {
					navItems[0].use = true
					navItems[length - 4].etc = true
				} else if (pageIndex === length - 3) {
					navItems[0].use = true
					navItems[length - 5].etc = true
					navItems[length - 1].use = true
				} else {
					navItems[0].use = true
					navItems[1].etc = true
					navItems[length - 2].etc = true
					navItems[length - 1].use = true
				}
			}

			navItems = _.filter(navItems, item => {
				return item.use || item.etc || item.on
			})

			return navItems
		},
	},

	oncreate() {
		this.observe('filteredItems', filteredItems => {
			if (filteredItems.length) {
				this.checkState()

				// check for a tag
				const params = new URLSearchParams(window.location.search)
				const tag = params.get('tag')
				if (tag) {
					this.set({ tag })
				}
			}
		})

		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => this.set({ items: json }))
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))

		// I hate this indirection, but it works...
		this.observe('yPosMirror', yPos => {
			this.set({ yPos })
		}, { init: false })
	},

	components: {
		Loader,
	},

	methods: {
		tween,
		navigate(direction) {
			let page = this.get('page')
			if (direction === 'previous') {
				--page
			} else if (direction === 'next') {
				++page
			} else {
				page = direction
			}
			const params = new URLSearchParams(window.location.search)
			params.set('page', page)
			history.pushState(null, '', window.location.pathname + '?' + params.toString())
			this.set({ page })

			// scroll up
			this.set({ yPosMirror: this.get('yPos') })
			this.tween('yPosMirror', 0, {
				duration: 1000,
				easing: eases.cubicOut,
			})
			// focus first item
			setFocus(this.refs.list)
		},
		clearTag() {
			const params = new URLSearchParams(window.location.search)
			params.delete('tag')
			params.set('page', 1)
			history.pushState(null, '', window.location.pathname + '?' + params.toString())
			this.set({
				page: 1,
				tag: undefined,
			})
		},
		checkState() {
			const params = new URLSearchParams(window.location.search)
			const page = parseInt(params.get('page'))
			if (page && page < this.get('navRange').length + 1) {
				// page loads search -> set page from params
				this.set({ page })
			} else {
				// page loads no search || out of range -> set params as default `1`
				params.set('page', 1)
				this.set({ page: 1 })
				history.replaceState(null, '', window.location.pathname + '?' + params.toString())
			}
			const tag = params.get('tag')
			if (tag) {
				this.set({ tag })
			} else if (this.get('tag')) {
				this.set({ tag: undefined })
			}
		},
	},

}

</script><:Window on:popstate="checkState()" bind:scrollY="yPos"/>{{#if tag}}
<div class="news-list-results">
  <h2 class="results"><strong>Results For: </strong>{{tag}}</h2>
  <button class="btn" on:click="clearTag()" aria-label="Load all news">All News</button>
</div>{{/if}}
<div class="news-list media-blocks mb" ref:list>
  <div class="list">{{#if paginatedItems.length}}{{#each paginatedItems as item}}
    <div class="media-block">
      <div class="img">{{#if item.image}}<img src="{{item.image}}" alt="{{item.imageAlt}}">{{else}}<img src="https://dummyimage.com/333x187/f2f3f2/f2f3f2.png" aria-hidden="true" alt="">{{/if}}
      </div>
      <div class="content">
        <div class="date">{{item.timestampFormatted}}</div>
        <h2 class="title"><a href="{{item.url}}">{{item.title}}</a></h2>
        <div class="body">{{item.summary}}</div>
      </div>
    </div>{{/each}}{{else}}
    <Loader></Loader>{{/if}}
  </div>{{#if navItems.length > 1 && paginatedItems.length}}
  <nav class="list-navigation" role="navigation" aria-label="News list">
    <ul>
      <li class="prev {{page <= 1 ? 'inactive' : ''}}">
        <button on:click="navigate('previous')" aria-hidden="{{page <= 1 ? 'true' : 'false'}}">
          <div class="ghost">Previous news item</div>
        </button>
      </li>{{#each navItems as item, index}}{{#if item.on}}
      <li class="on"><span>{{item.value}}</span></li>{{elseif item.etc}}
      <li class="etc" aria-hidden="true"><span>…</span></li>{{else}}
      <li>
        <button on:click="navigate(item.value)">{{item.value}}</button>
      </li>{{/if}}{{/each}}
      <li class="next {{page >= navRange.length ? 'inactive' : ''}}">
        <button on:click="navigate('next')" aria-hidden="{{page >= navRange.length ? 'true' : 'false'}}">
          <div class="ghost">Next news item</div>
        </button>
      </li>
    </ul>
  </nav>{{/if}}
</div>